export default function IconLibrary() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M12 3L2 7.5l10 4.5 10-4.5zM2 7.5v9M22 7.5v9M12 12v9M7 9.75v9M17 9.75v9"
        color="currentColor"
      />
    </svg>
  );
}
